import { hotList } from "@/mocks/baogua";

const deltaMap = {
  up: { icon: "ri-arrow-up-line", cls: "text-primary-600" },
  down: { icon: "ri-arrow-down-line", cls: "text-foreground-400" },
  new: { icon: "ri-sparkling-line", cls: "text-accent-600" },
  flat: { icon: "ri-arrow-right-line", cls: "text-foreground-400" },
};

export default function HotRank() {
  return (
    <section id="hot" className="w-full bg-gradient-to-b from-background-50 to-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
            <i className="ri-fire-fill"></i> 实时热搜
          </span>
          <h2 className="mt-3 text-2xl md:text-4xl font-bold text-foreground-950">
            全网正在吃的<span className="font-display text-accent-500">热瓜榜</span>
          </h2>
          <p className="mt-2 text-sm text-foreground-600 md:text-base">
            综合直播间热度、弹幕讨论量与转发数据实时滚动，红色向上代表正在发酵。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-3 lg:grid-cols-2">
          {hotList.map((h) => {
            const d = deltaMap[h.delta];
            return (
              <div key={h.rank} className="flex items-center gap-4 rounded-xl bg-background-50 px-4 py-3.5 transition hover:bg-background-50/80 hover:ring-1 hover:ring-primary-200">
                <span className={`font-display w-8 shrink-0 text-center text-2xl ${h.rank <= 3 ? "text-primary-500" : "text-foreground-300"}`}>
                  {h.rank}
                </span>
                <p className="min-w-0 flex-1 text-sm font-medium text-foreground-800 md:text-[15px]">{h.title}</p>
                <div className="hidden shrink-0 items-center gap-1 rounded-full bg-background-200/70 px-2.5 py-1 text-xs font-semibold text-primary-700 sm:flex">
                  {h.tag}
                </div>
                <div className="flex shrink-0 items-center gap-3">
                  <span className="text-xs text-foreground-500">{h.heat}</span>
                  <i className={`${d.icon} ${d.cls} text-base`}></i>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}